import axios from 'axios';
import { API_HOST } from '../consts';

const fetchStates = async (params) => {
  const res = await axios.get(`${API_HOST}/cities/state`, { params });
  return res.data;
};

export default fetchStates;
